import React, { useState } from "react";
import { IoLogOutOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PropagateLoader } from "react-spinners";
import LoadWallet from "../../components/modal/LoadWallet";

const Profile = () => {
  const [language, setLanguage] = useState("English");
  const [withdrawModal, setWithdrawModal] = useState(false);
  const [loadWalletModal, setLoadWalletModal] = useState(false);
  const [amount, setAmount] = useState(100);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [profileImage, setProfileImage] = useState(
    "https://t4.ftcdn.net/jpg/03/64/21/11/360_F_364211147_1qgLVxv1Tcq0Ohz3FawUfrtONzz8nq3e.jpg" // Default placeholder image
  );

  // Handle Image Change
  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
    }
  };

  const location = useLocation();
  const navigate = useNavigate();
  const profileInfoData = useSelector((state) => state?.profile?.data);
  const loading = useSelector((state) => state?.profile?.loading);
  const profileInfo = location.state?.profileInfo || profileInfoData;

  const handleMakePayment = async (amount) => {
    // const stripe = await loadStripe(process.env.STRIPE_PUBLIC_KEY);
    // console.log("stripe", stripe);
    // const options = {
    //   clientSecret: '{{process.env.REACT_APP_STRIPE_SECRET_KEY}}',
    // };
  };

  return (
    <>
      {loading ? (
        <div className="h-[80vh] flex items-center justify-center">
          <PropagateLoader color="#284184" loading={true} size={10} />
        </div>
      ) : (
        <>
          <div className="px-4 md:px-10">
            <div className="border border-1 px-4 py-1 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between items-center">
                <p className="text-[#284184] text-xl font-bold">Profile Info</p>
                <button className="text-[#F04438] flex items-center gap-2 px-4 py-2 rounded-md">
                  <IoLogOutOutline className="text-xl" /> Log out
                </button>
              </div>
            </div>
            <div className="border border-t-0 px-4 py-1 rounded-b-2xl text-xl bg-white">
              <div className="flex items-center space-x-4 mt-4">
                <img
                  src={
                    profileInfo?.profile_image ||
                    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqafzhnwwYzuOTjTlaYMeQ7hxQLy_Wq8dnQg&s"
                  }
                  alt="Profile"
                  className="w-16 h-16 rounded-xl object-cover"
                />
                <label
                  htmlFor="upload"
                  className="text-[#E0A256] text-base underline cursor-pointer"
                >
                  Change Photo
                </label>
                <input
                  type="file"
                  id="upload"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageChange}
                />
              </div>

              <div className="mt-4 border-b pb-3">
                <label className="text-base font-semibold">
                  First name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  className="w-full mt-1 px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400"
                  // defaultValue="Ricky"
                  value={profileInfo?.name}
                  readOnly
                />
              </div>

              {/* Language Selection */}
              <div className="mt-4 mb-3">
                <div className="flex items-center space-x-3 mt-2">
                  <p className="text-base font-semibold">Change Language:</p>
                  <button
                    className={`px-4 py-2 rounded-lg border ${
                      language === "English"
                        ? "bg-[#F4F9FF] border-[#7DA7FF]"
                        : "border-gray-300"
                    }`}
                    onClick={() => setLanguage("English")}
                  >
                    English
                  </button>
                  <button
                    className={`px-4 py-2 rounded-lg border ${
                      language === "French"
                        ? "bg-[#F4F9FF] border-[#7DA7FF]"
                        : "border-gray-300"
                    }`}
                    onClick={() => setLanguage("French")}
                  >
                    French
                  </button>
                </div>
              </div>
            </div>
            <div className="border border-1 px-4 py-3 rounded-t-2xl text-xl mt-4 bg-white">
              <div className="flex justify-between items-center">
                <p className="text-[#284184] text-xl font-bold">Wallet</p>
                <button
                  className="text-[#E0A256] text-base underline"
                  onClick={() => navigate("/transactions")}
                >
                  View Transactions
                </button>
              </div>
            </div>
            <div className="border border-t-0 px-3 py-1 rounded-b-2xl text-xl bg-white">
              <div className="flex border justify-center bg-white rounded-lg shadow-sm p-5 my-2">
                <div className="justify-items-center">
                  <p className="text-4xl font-semibold text-[#284184]">
                    ${profileInfo?.wallet_amount || 0}
                  </p>
                  <div className="flex gap-8">
                    <button
                      className="text-blue-600 text-base mt-2 underline"
                      onClick={() => {
                        setAmount(100);
                        setLoadWalletModal(true);
                      }}
                    >
                      Load Wallet
                    </button>
                    <button
                      className="text-blue-600 text-base mt-2 underline"
                      onClick={() => setWithdrawModal(true)}
                    >
                      Withdraw Balance
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <LoadWallet
            isOpen={loadWalletModal}
            onClose={() => {
              setLoadWalletModal(false);
              setSelectedIndex(0);
            }}
            setAmount={setAmount}
            amount={amount}
            handleMakePayment={handleMakePayment}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
          />
        </>
      )}
    </>
  );
};

export default Profile;
